export default __webpack_public_path__ + "static/media/jupiter.f60c5190.png";